import { LocalStorage } from './enums/storage';
import * as yup from 'yup';

const validationSchema = {
  [LocalStorage.RefreshToken]: yup.string(),
  [LocalStorage.RefreshExpiration]: yup.number(),
  [LocalStorage.DeviceToken]: yup.string(),
  [LocalStorage.Theme]: yup.string(),
  [LocalStorage.Language]: yup.string(),
  [LocalStorage.LastSiteViewed]: yup.string(),
  [LocalStorage.LastCompanyViewed]: yup.string(),
  [LocalStorage.DataUploadAdvancedMode]: yup.boolean(),
};

const load = async <T>(key: LocalStorage): Promise<T | null> => {
  let data: unknown;
  const item: string | null = localStorage.getItem(key);

  try {
    data = !item ? item : JSON.parse(item);
  } catch (error: unknown) {
    data = item;
  }

  return await validationSchema[key]
    .nullable() // All keys can be empty, which is fine and shouldnt raise an error
    .validate(data)
    .then((data: unknown) => data as T)
    .catch(() => null);
};

const save = (key: string, data: Record<string, unknown> | string | number | boolean): void => {
  if (typeof data === 'object') {
    const json = JSON.stringify(data);

    localStorage.setItem(key, json);

    return;
  } else if (typeof data === 'number') {
    localStorage.setItem(key, data.toString());

    return;
  } else if (typeof data === 'boolean') {
    localStorage.setItem(key, JSON.stringify(data));

    return;
  }

  localStorage.setItem(key, data);
};

const localState = { load, save };

export default localState;
